import { dispatchHandler } from '../helper/apiHelperFunctions'
import { getMenuMode } from '../helper/helperTableFunctions';
// import { parseJwt } from '../helper/genericFunction';

export const getAllAnnouncements = ({ dispatch }) => {
    // if(getMenuMode?.() == "new"){
        // window.location?.reload?.();
    // }else{
        dispatchHandler(dispatch, 'getAnnouncementRequest', {
            token: sessionStorage.getItem('token'),
            "flowType": "ENT_DETAILS"
        });
        dispatchHandler(dispatch, "getCurrrentUserEntModulesRequest", {
            flowType: "MODULES",
            token: sessionStorage.getItem("token"),
        })
    // }
};


